module.exports = __webpack_public_path__ + "img/30f1.ee8cdd33.jpg";